import { defineComponent as _defineComponent } from 'vue'
import AccountService from 'JS/services/AccountService';
import BButton from 'JS/components/BButton.vue';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import CreatePasswordField from 'JS/components/side-menus/account-creation/components/CreatePasswordField.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import FullScreenLoader from 'JS/components/FullScreenLoader.vue';
import Icon from 'JS/components/Icon.vue';
import { BButtonSubmitButton, BCheckbox } from 'JS/components/blain-form';
import { EventBusEvents } from 'JS/types/EventBus';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  props: {
    isActivatePage: { type: Boolean }
  },
  setup(__props: any) {



const accountService = new AccountService();
const queryParams = new URLSearchParams(window.location.search);
const email = queryParams.get('bid');
const authenticationToken = queryParams.get('at');
const token = (
	document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement
).value;

const password = ref<string>('');
const rememberMe = ref(true);
const response = ref<{ success: boolean }>(null);
const loading = ref(false);
const error = ref<string>();

async function submitNewPassword() {
	loading.value = true;
	try {
		response.value = await accountService.resetPassword(email, authenticationToken, password.value, token, rememberMe.value);

		if (response.value.success) {
			window.vueEventBus.$emit(EventBusEvents.LoginSuccess);
		}

	} catch (e) {
		bugsnagClient.notify(e);
		error.value = "<span class='bold'>Something went wrong.</span> Please try again later.";
		loading.value = false;
	}
}

function reloadIfNoResponse() {
	if (!response.value?.success) {
		window.location.reload();
	}
}

onMounted(() => {
	window.history.replaceState(null, "", window.location.origin);
	window.vueEventBus.$on(EventBusEvents.LoginSuccess, reloadIfNoResponse);
});

return { __sfc: true,accountService, queryParams, email, authenticationToken, token, password, rememberMe, response, loading, error, submitNewPassword, reloadIfNoResponse, BButton, BForm, CreatePasswordField, ErrorBanner, FullScreenLoader, Icon, BButtonSubmitButton, BCheckbox }
}

})